/**
 * The event card's search icon (2026-09-03 owner ask): one tap opens the
 * Nexus Dex with the box already holding the event's Pokémon, as the comma
 * list the box reads as OR-ed terms. Null when the event has no resolvable
 * species, so the icon simply does not render.
 */
const MAX_TERMS = 60;

export function eventDexSearchHref(
  spawns: readonly { speciesId?: number | null }[] | undefined,
): string | null {
  const ids: number[] = [];
  for (const s of spawns ?? []) {
    const id = s.speciesId;
    if (typeof id !== "number" || !Number.isFinite(id) || id < 1) continue;
    if (!ids.includes(id)) ids.push(id);
    if (ids.length >= MAX_TERMS) break;
  }
  if (ids.length === 0) return null;
  return `/dex?q=${encodeURIComponent(ids.join(","))}`;
}
